module.exports = __webpack_public_path__ + "static/icon-bf82b9199d4395661af20501fc43bfa6.png";